import React from 'react';
import { getSimulate, clearSimulate } from '../services/simulate';
import './SimulationBanner.css';

/**
 * Banner shown when "View as role" is active. Lets the user end simulation.
 */
function SimulationBanner({ onEnd }) {
  const sim = getSimulate();
  if (!sim) return null;

  const handleEnd = () => {
    clearSimulate();
    onEnd?.();
  };

  return (
    <div className="simulation-banner" role="status">
      <span className="simulation-banner-text">
        Viewing as <strong>{sim.roleName}</strong>
      </span>
      <button type="button" className="simulation-banner-end" onClick={handleEnd}>
        End
      </button>
    </div>
  );
}

export default SimulationBanner;
